export class EMA {
  private value: number;
  private alpha: number;

  constructor(alpha: number, initial: number) {
    this.alpha = alpha;
    this.value = initial;
  }

  update(sample: number): number {
    this.value = this.alpha * sample + (1 - this.alpha) * this.value;
    return this.value;
  }

  get(): number {
    return this.value;
  }

  reset(initial: number): void {
    this.value = initial;
  }
}
